import { useReveal } from "../../hooks/useReveal";
import { useI18n } from "../../i18n/useI18n";

const ICONS = ["◈", "❋", "✦"];

export function WhyVedic() {
  const scope = useReveal<HTMLElement>();
  const { t } = useI18n();
  return (
    <section id="why" ref={scope} className="relative py-24 md:py-32">
      <div className="container-lux">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow mb-4" data-reveal>{t.why.eyebrow}</p>
          <h2 className="text-3xl font-semibold md:text-5xl" data-reveal>{t.why.title}</h2>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {t.why.cards.map((c, i) => (
            <article
              key={c.title}
              data-reveal
              className="group rounded-3xl border border-slate-200/80 bg-white/80 p-8 shadow-xl shadow-amber-900/5 backdrop-blur-md transition-transform duration-500 ease-lux hover:-translate-y-1.5 hover:border-gold/40"
            >
              <span className="text-2xl text-gold">{ICONS[i]}</span>
              <h3 className="mt-4 text-2xl font-semibold">{c.title}</h3>
              <p className="text-sm font-medium uppercase tracking-wider text-gold-deep">{c.subtitle}</p>
              <p className="mt-3 text-slate2/80">{c.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
